import React from 'react';
import { motion } from 'framer-motion';
import { Globe, ThumbsUp, MessageCircle, Share2, Star } from 'lucide-react';
import { usePricing } from '../contexts/PricingContext';
export function TestimonialsSection() {
  const {
    formatPrice,
    currentPrice,
    isLoading
  } = usePricing();
  const dynamicPrice = isLoading ? '...' : formatPrice(currentPrice);
  const testimonials = [{
    name: 'Roberto M.',
    role: 'Líder de Estudio Bíblico',
    location: 'México',
    timestamp: 'Hace 2 h',
    avatarBg: 'bg-blue-600',
    quote: <span data-id="element-365">
          Llevo 15 años estudiando la Biblia y{' '}
          <span className="font-bold text-burgundy-700" data-id="element-366">
            NUNCA había entendido la geografía
          </span>{' '}
          como ahora. Cuando vi la{' '}
          <span className="highlight-gold font-medium" data-id="element-367">
            reconstrucción 3D de Jerusalén
          </span>{' '}
          en tiempos de Jesús, se me puso la piel de gallina.{' '}
          <span className="italic" data-id="element-368">
            Cada pasaje cobra un significado completamente nuevo.
          </span>
        </span>,
    reactions: {
      likes: 124,
      comments: 12,
      shares: 3
    },
    reactionEmojis: ['👍', '❤️', '😮'],
    comments: [{
      name: 'Ana G.',
      text: 'Amén hermano 🙏'
    }, {
      name: 'Luis T.',
      text: 'Yo también lo tengo, es increíble'
    }]
  }, {
    name: 'María Elena P.',
    role: 'Maestra de Escuela Dominical',
    location: 'Argentina',
    timestamp: 'Hace 1 día',
    avatarBg: 'bg-rose-600',
    quote: <span data-id="element-369">
          Compré un atlas bíblico de $90 el año pasado y{' '}
          <span className="italic text-gray-900" data-id="element-370">
            no se compara ni de lejos
          </span>
          . Las imágenes de Biblia Visual son{' '}
          <span className="font-bold text-navy-800" data-id="element-371">increíblemente claras</span>{' '}
          y el contexto arqueológico que incluye es de{' '}
          <span className="highlight-warm font-medium" data-id="element-372">nivel seminario</span>.
          Por {dynamicPrice} es{' '}
          <span className="font-bold text-green-700" data-id="element-373">ridículamente bueno</span>.
        </span>,
    reactions: {
      likes: 89,
      comments: 8,
      shares: 5
    },
    reactionEmojis: ['👍', '❤️'],
    comments: [{
      name: 'Carmen R.',
      text: '¡Gracias por compartir! 🙌'
    }]
  }, {
    name: 'Pastor Daniel R.',
    role: 'Pastor',
    location: 'Colombia',
    timestamp: 'Hace 3 h',
    avatarBg: 'bg-emerald-700',
    quote: <span data-id="element-374">
          Lo uso cada domingo para preparar mis sermones. Los mapas y las fotos
          reales hacen que mi congregación{' '}
          <span className="font-bold text-navy-800" data-id="element-375">
            entienda los pasajes como nunca antes
          </span>
          . Ya varios miembros me han pedido el enlace para{' '}
          <span className="underline-subtle font-medium" data-id="element-376">
            comprarlo ellos también
          </span>
          .
        </span>,
    reactions: {
      likes: 203,
      comments: 27,
      shares: 14
    },
    reactionEmojis: ['👍', '❤️', '😮'],
    comments: [{
      name: 'Sofía M.',
      text: 'Bendiciones pastor 🙏'
    }, {
      name: 'Jorge L.',
      text: '¿Dónde lo consigo?'
    }]
  }];
  return <section className="py-8 md:py-16 bg-gray-100 content-section" data-id="element-377">
      <div className="max-w-7xl mx-auto px-4 sm:px-6" data-id="element-378">
        <div className="text-center mb-6 md:mb-12" data-id="element-379">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-navy-900 mb-4" data-id="element-380">
            Escucha Lo Que Dicen Nuestros Lectores Satisfechos
          </h2>
          <div className="flex justify-center gap-1 text-gold-500" data-id="element-381">
            <Star className="fill-current w-5 h-5 md:w-6 md:h-6" data-id="element-382" />
            <Star className="fill-current w-5 h-5 md:w-6 md:h-6" data-id="element-383" />
            <Star className="fill-current w-5 h-5 md:w-6 md:h-6" data-id="element-384" />
            <Star className="fill-current w-5 h-5 md:w-6 md:h-6" data-id="element-385" />
            <Star className="fill-current w-5 h-5 md:w-6 md:h-6" data-id="element-386" />
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5 max-w-6xl mx-auto" data-id="element-387">
          {testimonials.map((t, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          delay: Math.min(index * 0.1, 0.3),
          duration: 0.4
        }} className="bg-white rounded-xl shadow-md overflow-hidden" data-id="element-388">
              {/* Facebook Post Header */}
              <div className="px-4 pt-4 pb-2 flex items-start gap-3" data-id="element-389">
                <div className={`w-10 h-10 ${t.avatarBg} rounded-full flex items-center justify-center text-white font-bold text-base flex-shrink-0 shadow-sm`} data-id="element-390">
                  {t.name.charAt(0)}
                </div>
                <div className="flex-1 min-w-0" data-id="element-391">
                  <div className="flex items-center gap-1" data-id="element-392">
                    <span className="font-bold text-sm text-gray-900 truncate" data-id="element-393">
                      {t.name}
                    </span>
                  </div>
                  <div className="flex items-center gap-1 text-xs text-gray-500" data-id="element-394">
                    <span data-id="element-395">
                      {t.role} · {t.location}
                    </span>
                  </div>
                  <div className="flex items-center gap-1 text-xs text-gray-400 mt-0.5" data-id="element-396">
                    <span data-id="element-397">{t.timestamp}</span>
                    <span data-id="element-398">·</span>
                    <Globe className="w-3 h-3" data-id="element-399" />
                  </div>
                </div>
              </div>

              {/* Post Content */}
              <div className="px-4 py-2" data-id="element-400">
                <p className="text-gray-800 text-sm md:text-base leading-relaxed text-left" data-id="element-401">
                  {t.quote}
                </p>
              </div>

              {/* Reaction Emoji Row + Count */}
              <div className="px-4 py-2 flex items-center justify-between" data-id="element-402">
                <div className="flex items-center gap-1" data-id="element-403">
                  <div className="flex -space-x-1" data-id="element-404">
                    {t.reactionEmojis.map((emoji, i) => <span key={i} className="w-5 h-5 rounded-full bg-white border border-white flex items-center justify-center text-xs shadow-sm" style={{
                  zIndex: t.reactionEmojis.length - i
                }} data-id="element-405">
                        {emoji}
                      </span>)}
                  </div>
                  <span className="text-xs text-gray-500 ml-1" data-id="element-406">
                    A {t.reactions.likes} personas les gusta esto
                  </span>
                </div>
              </div>

              {/* Engagement Stats */}
              <div className="px-4 pb-1 flex items-center justify-end" data-id="element-407">
                <span className="text-xs text-gray-400" data-id="element-408">
                  {t.reactions.comments} comentarios · {t.reactions.shares}{' '}
                  compartidos
                </span>
              </div>

              {/* Divider */}
              <div className="mx-4 border-t border-gray-200" data-id="element-409"></div>

              {/* Action Buttons */}
              <div className="px-2 py-1 flex items-center justify-around" data-id="element-410">
                <button className="flex items-center gap-1.5 px-3 py-1.5 rounded-md text-xs font-semibold text-gray-500 hover:bg-gray-50 transition-colors" data-id="element-411">
                  <ThumbsUp className="w-4 h-4" data-id="element-412" />
                  <span data-id="element-413">Me gusta</span>
                </button>
                <button className="flex items-center gap-1.5 px-3 py-1.5 rounded-md text-xs font-semibold text-gray-500 hover:bg-gray-50 transition-colors" data-id="element-414">
                  <MessageCircle className="w-4 h-4" data-id="element-415" />
                  <span data-id="element-416">Comentar</span>
                </button>
                <button className="flex items-center gap-1.5 px-3 py-1.5 rounded-md text-xs font-semibold text-gray-500 hover:bg-gray-50 transition-colors" data-id="element-417">
                  <Share2 className="w-4 h-4" data-id="element-418" />
                  <span data-id="element-419">Compartir</span>
                </button>
              </div>

              {/* Divider */}
              <div className="mx-4 border-t border-gray-200" data-id="element-420"></div>

              {/* Comment Previews */}
              <div className="px-4 py-3 space-y-3" data-id="element-421">
                {t.comments.map((comment, ci) => <div key={ci} className="flex items-start gap-2" data-id="element-422">
                    <div className="w-7 h-7 bg-gray-300 rounded-full flex items-center justify-center text-gray-600 font-bold text-xs flex-shrink-0" data-id="element-423">
                      {comment.name.charAt(0)}
                    </div>
                    <div className="bg-gray-100 rounded-2xl px-3 py-1.5" data-id="element-424">
                      <span className="font-bold text-xs text-gray-800" data-id="element-425">
                        {comment.name}
                      </span>
                      <p className="text-xs text-gray-600 leading-snug" data-id="element-426">
                        {comment.text}
                      </p>
                    </div>
                  </div>)}
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}